// extracted by mini-css-extract-plugin
export default {"root":"EditUserRoleModal_root__oLKLk","container":"EditUserRoleModal_container__56h8s"};